import { DeleteOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Button, Col, Form, message, Modal, Row, Spin, Typography } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useLoginModal } from '../../../../../context/loginModalContext'
import { showAuthError } from '../../../../../shared/utils/webHelpers'
import SearchField from '../../../../common/searchFields/SearchField'
import DELETE_REFERRAL_SUB_SOURCE from '@dentolize/clinic-mobile/src/shared/store/mutations/actions/referralSubSources/deleteReferralSubSource'
import SEARCH_REFERRAL_SOURCES from '@dentolize/clinic-mobile/src/shared/store/queries/actions/referralSubSources/searchReferralSubSources'

const DeleteReferralSubSourceButton = ({ selectedItem, handleAnimateRow, handleClose }) => {
  const [visible, setVisible] = useState(false)

  const { referralSubSource } = useParams()
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { setLoginModalVisible } = useLoginModal()

  const [deleteItem, { loading }] = useMutation(DELETE_REFERRAL_SUB_SOURCE, {
    update: handleUpdateAfterDelete
  })

  function handleUpdateAfterDelete(store) {
    store.data.delete(`ReferralSubSource:${selectedItem.id}`)
    handleAnimateRow && handleAnimateRow(null, true)
  }

  const { validateFields, scrollToField, resetFields } = form

  useEffect(() => {
    resetFields()
  }, [visible])

  const toggleVisible = () => setVisible(visible => !visible)

  const handleSubmit = () =>
    validateFields()
      .then(async values => {
        try {
          if (selectedItem.id === values.moveTo.key) {
            message.error(t('app.mergeError'))
            return
          }
          await deleteItem({
            variables: {
              referralSubSource: selectedItem.id,
              moveTo: values.moveTo.key
            }
          })
          referralSubSource && navigate(-1)
          handleClose && handleClose()
          message.success(t('common.deletedSuccess'))
          toggleVisible()
        } catch (e) {
          showAuthError(e, t, setLoginModalVisible)
        }
      })
      .catch(({ errorFields }) => {
        scrollToField(errorFields?.[0]?.name)
      })

  return (
    <>
      <Modal
        open={visible}
        title={t('common.delete')}
        okButtonProps={{
          loading,
          htmlType: 'submit',
          form: 'DeleteReferralSubSourceForm',
          'data-testid': 'referralSubSourceForm-delete-confirm'
        }}
        onCancel={toggleVisible}
      >
        <Spin spinning={loading}>
          <Typography.Text type="danger" strong>
            {t('app.mergePatientAlert', {
              val: selectedItem.name
            })}
          </Typography.Text>
          <br />
          <br />
          <Form onFinish={handleSubmit} form={form} name="DeleteReferralSubSourceForm" layout="vertical" scrollToFirstError>
            {selectedItem && selectedItem.referralSource ? (
              <Row type="flex" gutter={16}>
                <Col span={24}>
                  <SearchField
                    GET_QUERY={SEARCH_REFERRAL_SOURCES}
                    label={t('patients.newItem')}
                    fieldName="moveTo"
                    dataName="searchReferralSubSources"
                    rules={[{ required: true, message: t('app.fieldRequired') }]}
                    passToQuery={{ referralSource: selectedItem.referralSource.id }}
                  />
                </Col>
              </Row>
            ) : null}
          </Form>
        </Spin>
      </Modal>
      <Button type="primary" danger onClick={toggleVisible} icon={<DeleteOutlined />} data-testid="ReferralSubSourceForm-delete">
        {t('common.delete')}
      </Button>
    </>
  )
}

DeleteReferralSubSourceButton.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  handleAnimateRow: PropTypes.func
}

export default DeleteReferralSubSourceButton
